import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "produx_token";
export const getToken = () => (typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null);
export const setToken = (t) => {
    if (typeof window === "undefined") return;
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};

const api = axios.create({
    baseURL: API,
    withCredentials: true, // still keep cookies as fallback if browser accepts them
});

// Attach Bearer token to every request (works around Safari SameSite=None cookie rewriting)
api.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

// Global 401 handler: silent-fail auth-me checks, redirect on protected page errors
let redirecting = false;
api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        const isAuthProbe = url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
        if (status === 401 && !isAuthProbe && typeof window !== "undefined" && !redirecting) {
            if (!window.location.pathname.startsWith("/login")) {
                redirecting = true;
                setToken(null); // clear stale token
                setTimeout(() => { window.location.replace("/login"); }, 200);
            }
        }
        return Promise.reject(err);
    }
);

export default api;

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Errore imprevisto";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function downloadUrl(path) {
    return `${API}${path}`;
}
